import { GraphQLScalarType, Kind } from 'graphql'

export const HicTimeResolver = new GraphQLScalarType({
  name: 'Time',
  description: 'A time "hh:mm"',
  serialize(value: any) {
    if (value instanceof Date) {
      return `${('0' + value.getHours()).slice(-2)}:${('0' + value.getMinutes()).slice(-2)}`
    }
    throw new TypeError(`Provided value is not a valid Time ${value}`)
  },
  parseValue(value: any) {
    if (typeof value === 'string' && value.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)) {
      const time = value.split(':')
      return new Date(1970, 0, 1, +time[0], +time[1])
    }
    throw new TypeError(`Provided value is not a valid Time ${value}`)
  },
  parseLiteral(ast: any) {
    if (ast.kind === Kind.STRING && ast.value.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)) {
      const time = ast.value.split(':')
      return new Date(1970, 0, 1, +time[0], +time[1])
    }
    return null
  },
})
